<template>
  <div>
    <h2>Programs</h2>

    <div class="row">
      <div class="col-md-6">
        <programme-input programme-slug="welfarm"></programme-input>
      </div>
      <div class="col-md-6">
        <programme-input programme-slug="welcalf"></programme-input>
      </div>
    </div>

    <template v-for="programme in getFieldValue('programs')">
      <template v-if="!['welfarm', 'welcalf'].includes(programme.slug)">
        <programme-input :programme-slug="programme.slug" :key="programme.slug"> </programme-input>
      </template>
    </template>

    <div>
      <span class="form-group">
        <label>
          Program Involvement Notes
          <span class="glyphicon glyphicon-envelope" aria-hidden="true" data-toggle="tooltip" data-placement="top"
            title="Email might be generated"></span>
        </label>
        <comments field-name="program_involvement_notes" :isReadOnly="isReadOnly"></comments>
      </span>
    </div>
  </div>
</template>

<script>
import baseComponent from '@/mixins/base_consult_component_v2'

export default {
  name: 'Programmes',
  mixins: [baseComponent],
  methods: {
    toggleNotifications: function () {
      this.setEmailNotification({
        slug: 'notes-for-farm-services',
        value: Boolean(this.getFieldComment('notes_for_farm_services', 'ClientDetails').current),
      })
    },
  },
}
</script>
